module.exports = __webpack_public_path__ + "static/kran_lastendiagramm-41924969f9212631e71ce6cdceeb9af2.png";